// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"728":"b97149cf","917":"ba577c8d"}[chunkId] + ".chunk.css";
};